import * as actions from '../actions/TaskCountByStatusActions';

const initialState = {
  loading: true,
  error: null,
  data: {},
};

const taskCountByStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_TASK_COUNT_BY_STATUS:
      return initialState;
    case actions.GET_TASK_COUNT_BY_STATUS_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.data,
      };
    }
    case actions.GET_TASK_COUNT_BY_STATUS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    default:
      return state;
  }
};

export default taskCountByStatusReducer;
